export default __webpack_public_path__ + "static/media/Armguards of Baleful Blood.feb082b8.jpg";